export const initialServices = [];

export const initialProjects = [];

export const initialBtsPhotos = [];

export const initialBtsVideos = [];

export const initialMovies = [];

export const initialFounders = [];
